<template>
    <div class="infos">
        <!-- Speciality and date informations -->
        <div class="spec-date">
            <!-- Speciality div -->
            <div class="spec">
                <img src="../assets/specialite.svg" alt="specialite">
                <div class="spec-infos">
                    <span class="spec-name">{{consultation.speciality}}</span>
                    <span class="doctor-name">Dr. {{consultation.doctor}}</span>
                    <b><span class="cabinet">{{consultation.hospital}}</span></b>
                </div>
            </div>
            <!-- Date div -->
            <div class="date">
                <img src="../assets/date.svg" alt="date">
                <div class="date-infos">
                    <span class="date-title">Date du RDV</span>
                    <span class="date-content">{{consultation.dateRdv}}</span>    
                </div>
            </div>
        </div>
        <!-- Cout informations -->
        <!-- <div class="cout">
            <div class="cout-brut">
                <img src="../assets/cout.svg" alt="cout">
                <div class="cout-infos">
                    <span class="cout-label">Frais de la consultation</span>
                    <span class="cout-montant"><b>{{consultation.cost}} Fcfa</b></span>
                </div>
            </div>
            <div class="frais-transaction">
                <img src="../assets/cout.svg" alt="cout">
                <div class="cout-infos">
                    <span class="cout-label">Frais de transaction</span>
                    <span class="cout-montant"><b>{{consultation.fraisTransaction}} Fcfa</b></span>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    props: {
        consultation: [Object, String]
    }
}
</script>

<style>
/* Global styles */
.infos {
    border: 1px solid #eee;
    background: #fff;
    border-radius: 5px;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin: 50px;
}
span {
    display: block;
    text-align: left;
}

/* Speciality and date styles */
.spec-date {
    height: 50%;
    display: flex;
    border-bottom: 1px solid #eee;
    align-items: center;
}
.spec,.date {
    width: 50%;
    display: flex;
    padding: 0.625rem;
}

/* Speciality styles*/
.spec-infos {
    margin-left: 0.250rem;
}
.doctor-name {
    font-weight: bold;
}
.spec-name {
    font-size: 0.75rem;
}
.doctor-name{
    font-size: 0.53rem;
}
.cabinet {
    font-size: 0.42rem;
}
.doctor-name,.cabinet {
    color: #000;
}

/* Date styles */
.date-infos {
    margin-left: 0.250rem;
}
.date-title {
    font-size: 0.75rem;
}
.date-content {
    color: #000;
    font-size: 0.53rem;
    font-weight: bold;
}

/* Cout styles */
.cout {
    height: 50%;
    margin: auto;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 0.625rem;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
}
.cout-infos {
    margin-left: 0.250rem;
}
.cout-label {
    font-size: 0.75rem;
}
.cout-montant {
    font-weight: bold;
    color: #2BA359;
}
.cout-brut, 
.frais-transaction {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>
